"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.angleLessThan = exports.turn = exports.isAngleDifferenceWithin = exports.angleDifference = exports.angleTowards = exports.normalizeAngle = exports.calcAngleToXYLead = exports.calcAngleToIJ = exports.calcAngleToXY = void 0;
function calcAngleToXY(a, b) {
    return Math.atan2(b.y - a.y, b.x - a.x);
}
exports.calcAngleToXY = calcAngleToXY;
function calcAngleToIJ(a, b) {
    return Math.atan2(b.j - a.j, b.i - a.i);
}
exports.calcAngleToIJ = calcAngleToIJ;
function calcAngleToXYLead(a, b, ox, oy) {
    return Math.atan2(b.y - a.y + oy, b.x - a.x + ox);
}
exports.calcAngleToXYLead = calcAngleToXYLead;
// export function shortestArc(a: number, b: number) {
//   if (Math.abs(b - a) < Math.PI) {
//     return b - a
//   }
//   if (b > a) {
//     return b - a - Math.PI * 2.0
//   }
//   return b - a + Math.PI * 2.0
// }
function findTurnSide(a, b) {
    var diff = b - a;
    if (diff < 0) {
        diff += Math.PI * 2;
    }
    if (diff > Math.PI) {
        return -1;
    } // Left
    return 1; // Right turn
}
function normalizeAngle(a) {
    var pi2 = Math.PI * 2;
    if (a > pi2) {
        a -= Math.floor(a / pi2) * pi2;
    }
    if (a < 0) {
        a += Math.ceil(-a / pi2) * pi2;
    }
    return a;
}
exports.normalizeAngle = normalizeAngle;
function angleTowards(curAngle, targetAngle, max) {
    curAngle = normalizeAngle(curAngle);
    targetAngle = normalizeAngle(targetAngle);
    // Don't overshoot
    var diff = normalizeAngle(curAngle - targetAngle);
    if (Math.abs(diff) < max) {
        return targetAngle;
    }
    var dir = findTurnSide(curAngle, targetAngle);
    curAngle += dir * max;
    return normalizeAngle(curAngle);
}
exports.angleTowards = angleTowards;
function angleDifference(a, b) {
    return normalizeAngle(b - a);
}
exports.angleDifference = angleDifference;
function isAngleDifferenceWithin(a, b, e) {
    return angleLessThan(normalizeAngle(normalizeAngle(b) - normalizeAngle(a)), e);
}
exports.isAngleDifferenceWithin = isAngleDifferenceWithin;
exports.turn = Math.PI * 2;
function angleLessThan(a, e) {
    if (a < e) {
        return true;
    }
    if (a > Math.PI * 2 - e) {
        return true;
    }
    return false;
}
exports.angleLessThan = angleLessThan;
